import * as React from "react";

const ReferenceDescription = ({ description, title }) => {
  return (
    <div className="inner-title">
      <h3>{title}</h3>
      {description.map((element) => {
        return <div className="inner-title-element">{element}</div>;
      })}
    </div>
  );
};

export default ReferenceDescription;
